export default __webpack_public_path__ + "static/media/dashboard@2x.f7fcbca8.png";